import { create } from "zustand";

const initialState = {
  bomId: null,
  finishedGood: null,
  finishedGoodQuestions: null,
  components: null,
  componentQuestions: null,
  defaultCurrency: "USD",
  skipCreation: false,
  isCloning: false,
};

const useBomWizardStore = create((set) => ({
  ...initialState,
  setFinishedGood: (payload) => {
    set({ finishedGood: payload });
  },
  setDefaultCurrency: (payload) => {
    set({ defaultCurrency: payload });
  },
  setSkipCreation: (payload) => {
    set({ skipCreation: payload });
  },
  setFinishedGoodQuestions: (payload) => {
    set({ finishedGoodQuestions: payload });
  },
  setComponents: (payload) => {
    set({ components: payload });
  },
  setBomId: (payload) => {
    set({ bomId: payload });
  },
  setComponentQuestions: (payload) => {
    set({ componentQuestions: payload });
  },
  setIsCloning: (payload) => {
    set({ isCloning: payload });
  },
  clearState: () => {
    set({ ...initialState });
  },
}));

export default useBomWizardStore;
